function categoryItem(category, categories) {
  const children = categories
    .filter(candidate => candidate.parentId === category.id)
    .map(candidate => ({ id: candidate.id, label: candidate.name, href: `/category/${category.slug}/${candidate.slug}` }));

  return {
    id: category.id,
    label: category.name,
    href: `/category/${category.slug}`,
    children,
  };
}

function configuredItem(item, categories, pages) {
  let href = item.url || '#';
  let label = item.label || 'Link';

  if (item.type === 'category') {
    const category = categories.find(candidate => candidate.id === item.target);
    if (category) {
      href = `/category/${category.slug}`;
      label = item.label || category.name;
    }
  } else if (item.type === 'page') {
    const page = pages.find(candidate => candidate.id === item.target);
    if (page) {
      href = `/p/${page.slug}`;
      label = item.label || page.title;
    }
  }

  return {
    id: item.id || `${label}-${href}`,
    label,
    href,
    children: (item.children || []).map(child => configuredItem(child, categories, pages)),
  };
}

export function resolveTechnologyNavigation(siteSettings = {}, categories = [], pages = []) {
  const navigation = siteSettings.navigation || {};
  if (Array.isArray(navigation.header)) return resolveNavigationItems(navigation.header, siteSettings, categories, pages);
  const configured = Array.isArray(navigation.main) ? navigation.main : Array.isArray(navigation.header) ? navigation.header : [];
  const configuredItems = configured.map(item => configuredItem(item, categories, pages));
  const hasSubstantiveConfiguredNavigation = configuredItems.some(item => item.href !== '/');

  if (hasSubstantiveConfiguredNavigation) return configuredItems;

  return TECHNOLOGY_CATEGORY_NAVIGATION
    .map(label => categories.find(category => !category.parentId && category.name === label))
    .filter(Boolean)
    .map(category => categoryItem(category, categories));
}
export const TECHNOLOGY_CATEGORY_NAVIGATION = [
  'Latest',
  'News',
  'Reviews',
  'Big Tech',
  'Cybersecurity',
  'Entertainment',
  'Gaming',
];
import { resolveNavigationItems } from "../../../lib/publications/navigation.js";
